import { useQuery } from "@tanstack/react-query";
import { ISupplierInfo, ISupplierInfoDetails } from "./dtos";
import {
  GetAuthenticateSupplierInfo,
  getGetSupplierInfo,
  GetSupplierByCapacityLeadSecureId,
  GetSupplierInfoByWaitingListSecuredId
} from "../../constants/reactQueryKey";

// Definiere Mock-Daten
const mockSupplierInfoDetails: ISupplierInfoDetails = {
  supplierName: "Mock Supplier",
  farmerEmail: "farmer@mock.com",
  farmerName: "Farmer Joe",
  farmerImage: "https://via.placeholder.com/150",
  listOfBookings: [
    {
      bookingId: "1",
      bookingNumber: 1001,
      productId: 500,
      productName: "24 Stunden Betreuung"
    },
    {
      bookingId: "2",
      bookingNumber: 1002,
      productId: 501,
      productName: "Pflegehilfsmittel"
    },
    {
      bookingId: "3",
      bookingNumber: 1003,
      productId: 502,
      productName: "Pflegedienst"
    },
    {
      bookingId: "4",
      bookingNumber: 1004,
      productId: 503,
      productName: "Sitzlift"
    },
    {
      bookingId: "5",
      bookingNumber: 1005,
      productId: 504,
      productName: "Std. Betreuung"
    },
    {
      bookingId: "6",
      bookingNumber: 1006,
      productId: 505,
      productName: "Inkontinenzartikel"
    }
  ]
};

const mockSupplierInfo: ISupplierInfo = {
  supplierName: "Mock Supplier",
  supplierId: "mock-supplier-id"
};

export const useGetSupplierInfo = (
  supplierId: string,
  options?: { enabled: boolean }
) => {
  return useQuery(
    [getGetSupplierInfo, supplierId],
    async () => {
      // Simuliere eine API-Aufruf-Verzögerung
      await new Promise(resolve => setTimeout(resolve, 500));
      return mockSupplierInfoDetails;
    },
    {
      enabled: options?.enabled ?? true
    }
  );
};

export const useGetSupplierInfoBySecuredId = (
  securedId: string,
  options?: { enabled: boolean }
) => {
  return useQuery(
    [GetSupplierInfoByWaitingListSecuredId, securedId],
    async () => {
      await new Promise(resolve => setTimeout(resolve, 500));
      return mockSupplierInfo;
    },
    {
      enabled: options?.enabled ?? true
    }
  );
};

export const useGetAuthenticateSupplierInfo = (
  options?: { enabled: boolean }
) => {
  return useQuery(
    [GetAuthenticateSupplierInfo],
    async () => {
      await new Promise(resolve => setTimeout(resolve, 500));
      return mockSupplierInfo;
    },
    {
      enabled: options?.enabled ?? true
    }
  );
};

export const useGetSupplierInfoByCapacityLeadId = (
  securedId: string,
  options?: { enabled: boolean }
) => {
  return useQuery(
    [GetSupplierByCapacityLeadSecureId, securedId],
    async () => {
      await new Promise(resolve => setTimeout(resolve, 500));
      return mockSupplierInfo;
    },
    {
      enabled: options?.enabled ?? true
    }
  );
};
